import React from 'react';

interface IconVendorsProps {
    iconClasses?: string;
}

const IconVendors: React.FC<IconVendorsProps> = ({ iconClasses }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-vendors ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M9.91536 12.25V11.0833C9.91536 10.4645 9.66953 9.871 9.23195 9.43342C8.79436 8.99583 8.20087 8.75 7.58203 8.75H2.91536C2.29653 8.75 1.70303 8.99583 1.26545 9.43342C0.827864 9.871 0.582031 10.4645 0.582031 11.0833V12.25"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
            <path
                d="M5.2513 6.41667C6.53997 6.41667 7.58464 5.372 7.58464 4.08333C7.58464 2.79467 6.53997 1.75 5.2513 1.75C3.96264 1.75 2.91797 2.79467 2.91797 4.08333C2.91797 5.372 3.96264 6.41667 5.2513 6.41667Z"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
            <path
                d="M13.418 12.25V11.0833C13.4176 10.5663 13.2455 10.0641 12.9288 9.65552C12.612 9.24692 12.1685 8.95508 11.668 8.82583"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
            <path
                d="M9.33203 1.82583C9.83394 1.95434 10.2788 2.24624 10.5965 2.65552C10.9142 3.06479 11.0866 3.56815 11.0866 4.08625C11.0866 4.60435 10.9142 5.10771 10.5965 5.51699C10.2788 5.92626 9.83394 6.21816 9.33203 6.34667"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
        </svg>
    );
};

export default IconVendors;
